import type { TFunction } from 'i18next';
import type { BaseApiResponse } from './types/api-request';

import { toast } from 'react-hot-toast';

import { defaultResponseParser } from './base-request';
import { parseResponseErrors, ResponseError } from './response-errors';

export type fetchOauthLoginType = Promise<
  [{ url: string } | null, Record<string, string> | null, number | null]
>;

export type oAuthResponse = BaseApiResponse<{
  url: string;
}> & {
  type: string;
  headers: Headers;
};

export type apiRequestFnType<T> = (
  payload: T,
  queryParams: string,
) => Promise<Response>;

export async function fetchOauthHelper<T>(
  values: T,
  apiRequestFn: apiRequestFnType<T>,
  queryParams: string,
  t: TFunction,
): fetchOauthLoginType {
  try {
    const response = await defaultResponseParser<oAuthResponse>(
      await apiRequestFn(values, queryParams),
    );

    const { ok, body, status } = response;

    if (!ok || !body) {
      throw parseResponseErrors(body, status);
    }
    return [{ url: body.url }, null, status];
  } catch (error) {
    let errors;
    if (!(error instanceof ResponseError)) {
      toast.error(t('Form.CommunicationErrorMessage'));
      errors = { global: t('Form.CommunicationErrorMessage') };
    } else {
      if (error.message === 'invalid_credentials') {
        toast.error(t('Global.ErrorInvalidLoginOrPassword'));
        errors = { global: t('Global.ErrorInvalidLoginOrPassword') };
      } else {
        errors = { ...error.errors };
        return [null, errors, error?.status || 0];
      }
    }
    return [null, errors, 0];
  }
}
